import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, FilterIcon } from 'lucide-react';
const TeamBoxscore = () => {
  const [selectedGame, setSelectedGame] = useState('latest');
  const [sortConfig, setSortConfig] = useState({
    key: 'pts',
    direction: 'desc'
  });
  // Mock data for recent games
  const games = [{
    id: 'latest',
    opponent: 'Los Angeles Lakers',
    date: 'March 15, 2024',
    score: '112-108',
    result: 'W'
  }, {
    id: 'game2',
    opponent: 'Brooklyn Nets',
    date: 'March 12, 2024',
    score: '106-98',
    result: 'W'
  }, {
    id: 'game3',
    opponent: 'Philadelphia 76ers',
    date: 'March 10, 2024',
    score: '95-102',
    result: 'L'
  }, {
    id: 'game4',
    opponent: 'Miami Heat',
    date: 'March 8, 2024',
    score: '109-104',
    result: 'W'
  }, {
    id: 'game5',
    opponent: 'Cleveland Cavaliers',
    date: 'March 5, 2024',
    score: '115-118',
    result: 'L'
  }];
  // Mock boxscore data for players
  const playerStats = [{
    id: 1,
    name: 'Jalen Brunson',
    position: 'PG',
    min: '36:42',
    pts: 28,
    reb: 5,
    ast: 8,
    stl: 2,
    blk: 0,
    to: 3,
    pf: 2,
    fgm: 10,
    fga: 18,
    fg_pct: 55.6,
    tpm: 3,
    tpa: 7,
    tp_pct: 42.9,
    ftm: 5,
    fta: 6,
    ft_pct: 83.3,
    plus_minus: +12
  }, {
    id: 2,
    name: 'Julius Randle',
    position: 'PF',
    min: '34:15',
    pts: 22,
    reb: 12,
    ast: 4,
    stl: 1,
    blk: 1,
    to: 2,
    pf: 3,
    fgm: 8,
    fga: 17,
    fg_pct: 47.1,
    tpm: 2,
    tpa: 6,
    tp_pct: 33.3,
    ftm: 4,
    fta: 5,
    ft_pct: 80.0,
    plus_minus: +8
  }, {
    id: 3,
    name: 'OG Anunoby',
    position: 'SF',
    min: '32:08',
    pts: 16,
    reb: 7,
    ast: 2,
    stl: 3,
    blk: 2,
    to: 1,
    pf: 2,
    fgm: 6,
    fga: 11,
    fg_pct: 54.5,
    tpm: 2,
    tpa: 5,
    tp_pct: 40.0,
    ftm: 2,
    fta: 2,
    ft_pct: 100.0,
    plus_minus: +14
  }, {
    id: 4,
    name: 'Josh Hart',
    position: 'SG',
    min: '38:20',
    pts: 12,
    reb: 9,
    ast: 5,
    stl: 1,
    blk: 0,
    to: 0,
    pf: 1,
    fgm: 5,
    fga: 9,
    fg_pct: 55.6,
    tpm: 2,
    tpa: 4,
    tp_pct: 50.0,
    ftm: 0,
    fta: 0,
    ft_pct: 0.0,
    plus_minus: +10
  }, {
    id: 5,
    name: 'Isaiah Hartenstein',
    position: 'C',
    min: '28:45',
    pts: 10,
    reb: 11,
    ast: 3,
    stl: 0,
    blk: 2,
    to: 1,
    pf: 4,
    fgm: 5,
    fga: 7,
    fg_pct: 71.4,
    tpm: 0,
    tpa: 0,
    tp_pct: 0.0,
    ftm: 0,
    fta: 1,
    ft_pct: 0.0,
    plus_minus: +6
  }, {
    id: 6,
    name: 'Donte DiVincenzo',
    position: 'SG',
    min: '22:15',
    pts: 9,
    reb: 3,
    ast: 2,
    stl: 1,
    blk: 0,
    to: 1,
    pf: 2,
    fgm: 3,
    fga: 8,
    fg_pct: 37.5,
    tpm: 3,
    tpa: 7,
    tp_pct: 42.9,
    ftm: 0,
    fta: 0,
    ft_pct: 0.0,
    plus_minus: -4
  }, {
    id: 7,
    name: 'Miles McBride',
    position: 'PG',
    min: '16:18',
    pts: 8,
    reb: 1,
    ast: 2,
    stl: 0,
    blk: 0,
    to: 1,
    pf: 1,
    fgm: 3,
    fga: 5,
    fg_pct: 60.0,
    tpm: 2,
    tpa: 3,
    tp_pct: 66.7,
    ftm: 0,
    fta: 0,
    ft_pct: 0.0,
    plus_minus: -2
  }, {
    id: 8,
    name: 'Precious Achiuwa',
    position: 'PF',
    min: '18:47',
    pts: 7,
    reb: 6,
    ast: 0,
    stl: 0,
    blk: 1,
    to: 0,
    pf: 2,
    fgm: 3,
    fga: 6,
    fg_pct: 50.0,
    tpm: 0,
    tpa: 1,
    tp_pct: 0.0,
    ftm: 1,
    fta: 2,
    ft_pct: 50.0,
    plus_minus: -6
  }, {
    id: 9,
    name: 'Alec Burks',
    position: 'SG',
    min: '12:20',
    pts: 0,
    reb: 2,
    ast: 1,
    stl: 0,
    blk: 0,
    to: 1,
    pf: 1,
    fgm: 0,
    fga: 4,
    fg_pct: 0.0,
    tpm: 0,
    tpa: 2,
    tp_pct: 0.0,
    ftm: 0,
    fta: 0,
    ft_pct: 0.0,
    plus_minus: -8
  }];
  // Calculate team totals
  const teamTotals = playerStats.reduce((totals, player) => {
    return {
      min: '',
      pts: totals.pts + player.pts,
      reb: totals.reb + player.reb,
      ast: totals.ast + player.ast,
      stl: totals.stl + player.stl,
      blk: totals.blk + player.blk,
      to: totals.to + player.to,
      pf: totals.pf + player.pf,
      fgm: totals.fgm + player.fgm,
      fga: totals.fga + player.fga,
      fg_pct: 0,
      tpm: totals.tpm + player.tpm,
      tpa: totals.tpa + player.tpa,
      tp_pct: 0,
      ftm: totals.ftm + player.ftm,
      fta: totals.fta + player.fta,
      ft_pct: 0,
      plus_minus: totals.plus_minus + player.plus_minus
    };
  }, {
    min: '',
    pts: 0,
    reb: 0,
    ast: 0,
    stl: 0,
    blk: 0,
    to: 0,
    pf: 0,
    fgm: 0,
    fga: 0,
    fg_pct: 0,
    tpm: 0,
    tpa: 0,
    tp_pct: 0,
    ftm: 0,
    fta: 0,
    ft_pct: 0,
    plus_minus: 0
  });
  // Calculate percentages for totals
  teamTotals.fg_pct = Number((teamTotals.fgm / teamTotals.fga * 100).toFixed(1));
  teamTotals.tp_pct = Number((teamTotals.tpm / teamTotals.tpa * 100).toFixed(1));
  teamTotals.ft_pct = Number((teamTotals.ftm / teamTotals.fta * 100).toFixed(1));
  // Sort players based on current sort configuration
  const sortedPlayers = [...playerStats].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });
  // Handle sort request
  const requestSort = key => {
    let direction = 'desc';
    if (sortConfig.key === key && sortConfig.direction === 'desc') {
      direction = 'asc';
    }
    setSortConfig({
      key,
      direction
    });
  };
  // Render sort icon
  const renderSortIcon = key => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === 'asc' ? <ChevronUpIcon className="w-3 h-3 inline ml-1" data-id="element-20" data-mp="u5kfxvctm8vv" /> : <ChevronDownIcon className="w-3 h-3 inline ml-1" data-id="element-21" data-mp="fa4gfath1ks3" />;
  };
  return <div className="bg-white rounded-lg shadow-md" data-id="element-22" data-mp="fcqqpi7qyee0">
      <div className="p-4 border-b flex justify-between items-center" data-id="element-23" data-mp="k860nz2mvq55">
        <h3 className="font-semibold" data-id="element-24" data-mp="15e01kayy5gt">BOXSCORE</h3>
        <div className="flex items-center" data-id="element-25" data-mp="166yzz3orqoe">
          <div className="relative" data-id="element-26" data-mp="3sj049u7crkao">
            <select value={selectedGame} onChange={e => setSelectedGame(e.target.value)} className="pl-3 pr-8 py-1 text-sm border rounded-md appearance-none bg-white" data-id="element-27" data-mp="3shyv5v9wd7vl">
              {games.map(game => <option key={game.id} value={game.id} data-id="element-28" data-mp="3imoqt0w10oen">
                  {game.date} vs {game.opponent} ({game.result})
                </option>)}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" data-id="element-29" data-mp="f4ww3eqi9qcr">
              <ChevronDownIcon className="w-4 h-4" data-id="element-30" data-mp="a4r7k7fj8jyw" />
            </div>
          </div>
          <button className="ml-2 p-1 text-gray-500 hover:text-gray-700" data-id="element-31" data-mp="56z5wlp35jhi">
            <FilterIcon className="w-4 h-4" data-id="element-32" data-mp="58tq1xsj97kj" />
          </button>
        </div>
      </div>
      <div className="p-4" data-id="element-33" data-mp="2utor7aqjwa1u">
        <div className="mb-4 flex justify-between items-center" data-id="element-34" data-mp="2pwy96hv6r4ds">
          <div data-id="element-35" data-mp="2pyswu3xudalk">
            <h4 className="text-lg font-medium" data-id="element-36" data-mp="15ensqx12rsfs">New York Knicks</h4>
            <p className="text-sm text-gray-600" data-id="element-37" data-mp="15g8kyfzx2zah">
              {selectedGame === 'latest' ? 'vs Los Angeles Lakers (W 112-108)' : games.find(g => g.id === selectedGame)?.opponent}
            </p>
          </div>
          <div className="text-sm text-gray-600" data-id="element-38" data-mp="1faqsjw8gfezk">
            {selectedGame === 'latest' ? 'March 15, 2024' : games.find(g => g.id === selectedGame)?.date}
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-39" data-mp="1p23op01acrbe">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-40" data-mp="1t3ykjp0g6chs">
            <thead className="bg-gray-50" data-id="element-41" data-mp="1t6bd0w3u0593">
              <tr data-id="element-42" data-mp="1y2tg7rjijvjb">
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider sticky left-0 bg-gray-50" data-id="element-43" data-mp="1y4cw3h19c4kk">
                  PLAYER
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-44" data-mp="3qbyezhg1nm2">
                  POS
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-45" data-mp="2alnndrvgdwji">
                  MIN
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('pts')} data-id="element-46" data-mp="25mkjwbv4fydn">
                  PTS {renderSortIcon('pts')}
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('reb')} data-id="element-47" data-mp="1rmjgaonh2cuh">
                  REB {renderSortIcon('reb')}
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('ast')} data-id="element-48" data-mp="21mtvufwzbwct">
                  AST {renderSortIcon('ast')}
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('stl')} data-id="element-49" data-mp="381b8p1kmbk3s">
                  STL {renderSortIcon('stl')}
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('blk')} data-id="element-50" data-mp="3kkyf7ht6t8c3">
                  BLK {renderSortIcon('blk')}
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('to')} data-id="element-51" data-mp="3antvrpqq7qyz">
                  TO {renderSortIcon('to')}
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('pf')} data-id="element-52" data-mp="3pjjk3ujdwg6v">
                  PF {renderSortIcon('pf')}
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-53" data-mp="l38owcksdht6">
                  FG
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-54" data-mp="2e90nlkhwdhvs">
                  3P
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-55" data-mp="24b4fl1k9b31w">
                  FT
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => requestSort('plus_minus')} data-id="element-56" data-mp="298mf61cdw5x8">
                  +/- {renderSortIcon('plus_minus')}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-57" data-mp="1lm66mxkah0n2">
              {sortedPlayers.map(player => <tr key={player.id} className="hover:bg-gray-50" data-id="element-58" data-mp="1qkhhnbmblh6v">
                  <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900 sticky left-0 bg-white" data-id="element-59" data-mp="1cjetmtbrlwtb">
                    {player.name}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-60" data-mp="xx7zqeq2fa7i">
                    {player.position}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-61" data-mp="szg8lmx8vs4d">
                    {player.min}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 font-medium" data-id="element-62" data-mp="16vjn87vmxrvq">
                    {player.pts}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-63" data-mp="1gv26sn7mvbn9">
                    {player.reb}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-64" data-mp="1buwhhdou618c">
                    {player.ast}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-65" data-mp="1lmk5t5q3j25l">
                    {player.stl}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-66" data-mp="1zmuymeayuqte">
                    {player.blk}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-67" data-mp="sacer5zniwt9">
                    {player.to}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-68" data-mp="wch6fz6jhjd9">
                    {player.pf}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-69" data-mp="118xr2jej5fll">
                    {player.fgm}-{player.fga} ({player.fg_pct}%)
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-70" data-mp="1b0ak3ec2ebt7">
                    {player.tpm}-{player.tpa} ({player.tp_pct}%)
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-71" data-mp="1k2bhqcb7mzve">
                    {player.ftm}-{player.fta} ({player.ft_pct}%)
                  </td>
                  <td className={`px-3 py-2 whitespace-nowrap text-sm font-medium ${player.plus_minus >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-72" data-mp="3lsvbzpb3ly41">
                    {player.plus_minus > 0 ? `+${player.plus_minus}` : player.plus_minus}
                  </td>
                </tr>)}
              {/* Team totals row */}
              <tr className="bg-gray-50 font-medium" data-id="element-73" data-mp="3eh71me1ozev4">
                <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900 sticky left-0 bg-gray-50" data-id="element-74" data-mp="3efnnou3idfwi">
                  TEAM TOTALS
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-75" data-mp="34kvs1vthl34d"></td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-76" data-mp="60ccs2hqbv01">
                  240:00
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 font-medium" data-id="element-77" data-mp="10hkbuib2xcv">
                  {teamTotals.pts}
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-78" data-mp="3o81pfmul6mio">
                  {teamTotals.reb}
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-79" data-mp="2gv1gdhkwlklp">
                  {teamTotals.ast}
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-80" data-mp="4jorq5kgakfs">
                  {teamTotals.stl}
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-81" data-mp="9ax2b4xiobuj">
                  {teamTotals.blk}
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-82" data-mp="3qosh3rk761v6">
                  {teamTotals.to}
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-83" data-mp="n9n24sbq0pml">
                  {teamTotals.pf}
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-84" data-mp="s881kpj5f59z">
                  {teamTotals.fgm}-{teamTotals.fga} ({teamTotals.fg_pct}%)
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-85" data-mp="i9ihqr7ozar3">
                  {teamTotals.tpm}-{teamTotals.tpa} ({teamTotals.tp_pct}%)
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500" data-id="element-86" data-mp="331avkdrj000n">
                  {teamTotals.ftm}-{teamTotals.fta} ({teamTotals.ft_pct}%)
                </td>
                <td className={`px-3 py-2 whitespace-nowrap text-sm font-medium ${teamTotals.plus_minus >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-87" data-mp="2qiozbzs5eu90">
                  {teamTotals.plus_minus > 0 ? `+${teamTotals.plus_minus}` : teamTotals.plus_minus}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* Quarter-by-quarter score */}
        <div className="mt-8" data-id="element-88" data-mp="2copaytyqhuzg">
          <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-89" data-mp="27sh0vuze8rz5">
            QUARTER BREAKDOWN
          </h4>
          <div className="overflow-x-auto" data-id="element-90" data-mp="2mh3dvq1jt7n7">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-91" data-mp="2miy15b0albug">
              <thead className="bg-gray-50" data-id="element-92" data-mp="2hpd17df527sm">
                <tr data-id="element-93" data-mp="1u0kdg48o7693">
                  <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-94" data-mp="1u00t6gvjs5rw">
                    TEAM
                  </th>
                  <th scope="col" className="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-95" data-mp="1ozmtpn80i45h">
                    1Q
                  </th>
                  <th scope="col" className="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-96" data-mp="2ipdlq4yrvwsx">
                    2Q
                  </th>
                  <th scope="col" className="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-97" data-mp="2sfyj5p2pmva9">
                    3Q
                  </th>
                  <th scope="col" className="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-98" data-mp="1zrstcnwsug3k">
                    4Q
                  </th>
                  <th scope="col" className="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-99" data-mp="24trwbwomnazz">
                    TOTAL
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-100" data-mp="3l5f6477k9jz3">
                <tr data-id="element-101" data-mp="3l7rvh5fnewm6">
                  <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-102" data-mp="19i277zjuvwes">
                    New York Knicks
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-center text-gray-500" data-id="element-103" data-mp="14jqwznpnfjw1">
                    28
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-center text-gray-500" data-id="element-104" data-mp="utp84tph1xg2">
                    32
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-center text-gray-500" data-id="element-105" data-mp="qslrw63ihzeb">
                    26
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-center text-gray-500" data-id="element-106" data-mp="lv3qd0rtqmgc">
                    26
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-medium text-gray-900" data-id="element-107" data-mp="bvmqx13614st">
                    112
                  </td>
                </tr>
                <tr data-id="element-108" data-mp="2682shol0nurc">
                  <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-109" data-mp="269nn1e7bzdp7">
                    Los Angeles Lakers
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-center text-gray-500" data-id="element-110" data-mp="1k2boo46cdgb8">
                    24
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-center text-gray-500" data-id="element-111" data-mp="169vkv15m9e99">
                    30
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-center text-gray-500" data-id="element-112" data-mp="1aa5nc3u79mjd">
                    28
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-center text-gray-500" data-id="element-113" data-mp="11c3q7zdl7e1d">
                    26
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-medium text-gray-900" data-id="element-114" data-mp="ndvprhhcdulg">
                    108
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
};
export default TeamBoxscore;